"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isYoutubeVideo = exports.isVimeoVideo = exports.getYoutubeVideoId = exports.getVideoParts = void 0;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var videoRegex = "(?:(https?):)?//"; // protocol, http is optional
videoRegex += "(.*?)/"; // domain
videoRegex += "(.*?)"; // path
// eslint-disable-next-line no-useless-escape
videoRegex += "(?:.(.*))?$"; // extension, optional

var EXTENSION_MIME_TYPE = {
  mp4: "video/mp4",
  avi: "video/x-msvideo",
  mov: "video/quicktime",
  wmv: "video/x-ms-wmv",
  flv: "video/x-flv",
  webm: "video/webm",
  mkv: "video/x-matroska"
};
var getVideoParts = function getVideoParts(url) {
  var VIDEO_REGEX = new RegExp(videoRegex, "igm");
  var videoUrlParts = VIDEO_REGEX.exec(url);
  if (videoUrlParts) {
    var _videoUrlParts = _slicedToArray(videoUrlParts, 5),
      _url = _videoUrlParts[0],
      protocol = _videoUrlParts[1],
      domain = _videoUrlParts[2],
      path = _videoUrlParts[3],
      extension = _videoUrlParts[4];
    var videoParts = {
      url: _url,
      protocol: protocol,
      domain: domain,
      path: path,
      extension: extension,
      mimeType: EXTENSION_MIME_TYPE[extension]
    };
    return videoParts;
  }
};
exports.getVideoParts = getVideoParts;
var getYoutubeVideoId = function getYoutubeVideoId(url) {
  var watchVideoIdRegex = /(?:v=([^&\n]*))|(?:\/v\/([^?\n]*))ig/;
  var ytVideoParts = watchVideoIdRegex.exec(url);
  if (ytVideoParts) {
    return ytVideoParts[1];
  }
};
exports.getYoutubeVideoId = getYoutubeVideoId;
var isYoutubeVideo = function isYoutubeVideo(videoParts) {
  if (videoParts) {
    return videoParts.domain.includes("youtube") || videoParts.domain.includes("youtu.be");
  }
};
exports.isYoutubeVideo = isYoutubeVideo;
var isVimeoVideo = function isVimeoVideo(videoParts) {
  if (videoParts) {
    return videoParts.domain.includes("vimeo");
  }
};
exports.isVimeoVideo = isVimeoVideo;